import { useEffect, useState } from 'react';
import { DeliveryFeeModel } from '../../../models/deliveryFee';
import axios from 'axios';
import { DELETE_DELIVERY_FEE, FIND_MANY_DELIVERY_FEE } from '../../../lib/endpoints/deliveryFee';

export const useDeliveryFeeController = () => {
  const [orderAccept, setOrderAccept] = useState<boolean>(false);

  const [data, setData] = useState<DeliveryFeeModel[]>([]);
  const [selectedData, setSelectedData] = useState<DeliveryFeeModel>(null!);
  const [selectedId, setSelectedId] = useState<string>(null!);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingDeleteButton, setLoadingDeleteButton] = useState<boolean>(false);

  const [openMenu, setOpenMenu] = useState(null);
  const [openDeleteForm, setOpenDeleteForm] = useState<boolean>(false);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const handleFetchData = async () => {
    try {
      setLoadingData(true);
      const res = await axios.get(FIND_MANY_DELIVERY_FEE);
      setData(res?.data?.data);
    } catch (err) {
    } finally {
      setLoadingData(false);
    }
  };

  const handleDeleteDeliveryFee = async () => {
    try {
      setLoadingDeleteButton(true);
      setOpenMenu(null);
      await axios.delete(DELETE_DELIVERY_FEE + selectedId);
      await handleFetchData();
      setOpenDeleteForm(false);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingDeleteButton(false);
    }
  };

  const onAcceptOrder = (newValue: boolean) => {
    setOrderAccept(newValue);
  };

  const handleOpenEditForm = () => {
    setOpenForm(true);
    const getData = filterData.filter((item: DeliveryFeeModel) => item.id === selectedId)[0];
    setSelectedData(getData);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
  };

  const handleOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleOpenDeleteForm = () => {
    setOpenDeleteForm(true);
  };

  const handleCloseDeleteForm = () => {
    setOpenDeleteForm(false);
  };

  const filterData = data;

  const rows: DeliveryFeeModel[] = filterData?.slice((currentPage - 1) * 10, currentPage * 10);

  const countPagination = Math.ceil(filterData.length / 10);

  useEffect(() => {
    handleFetchData();
  }, []);

  return {
    onAcceptOrder,
    orderAccept,
    handleCloseMenu,
    handleOpenMenu,
    handleCloseForm,
    handleOpenForm,
    openForm,
    openMenu,
    rows,
    countPagination,
    handleChangePage,
    currentPage,
    loadingData,
    handleOpenEditForm,
    selectedData,
    setSelectedDataState: (newValue: DeliveryFeeModel) => setSelectedData(newValue),
    openDeleteForm,
    handleOpenDeleteForm,
    handleCloseDeleteForm,
    handleDeleteDeliveryFee,
    loadingDeleteButton,
    handleFetchData,
  };
};
